// extracted by mini-css-extract-plugin
export default {"questionsSelector":"questionsSelector-Ba0lx","selectAllCheckbox":"selectAllCheckbox-iKaaX"};